const respiratoryDiseasesAr = [
    "Asthma",
    "Chronic Obstructive Pulmonary Disease (COPD)",
    "Pneumonia",
    "Influenza (Flu)",
    "Tuberculosis (TB)",
    "Bronchitis",
    "Interstitial Lung Disease",
    "Cystic Fibrosis",
    "Lung Cancer",
    "Sleep Apnea",
    "Pulmonary Fibrosis",
    "Sarcoidosis",
    "Bronchiectasis",
    "Respiratory Syncytial Virus (RSV) Infection",
    "Laryngitis",
    "Idiopathic Pulmonary Fibrosis (IPF)",
    "Pulmonary Hypertension",
    "Pleurisy",
    "Silicosis",
    "Asbestosis",
    "Hantavirus Pulmonary Syndrome",
    "Occupational Lung Diseases",
    "Respiratory Distress Syndrome (ARDS)",
    "Hemoptysis",
]

const respiratory = respiratoryDiseasesAr.reduce((accumulator, disease) => {
    accumulator.push({category: 'Respiratory', disease})
    return accumulator
}, [])

export default respiratory